import { FileUpload } from '../../../../model/FileUpload';
import { UploadService } from '../../../../service/upload.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adm-portfolio',
  templateUrl: './adm-portfolio.component.html',
  styleUrls: ['./adm-portfolio.component.scss']
})
export class AdmPortfolioComponent implements OnInit {

  selectedFiles: FileList;
  currentFileUpload: FileUpload;
  progress: {percentage: number} = { percentage: 0 };

  constructor(private uploadService: UploadService) {}

  ngOnInit() {
  }

  selectFile(event) {
    const file = event.target.files.item(0);

    if (file.type.match('image.*')) {
      this.selectedFiles = event.target.files;
    } else {
      alert('invalid format!');
    }
  }

  upload() {
    const file = this.selectedFiles.item(0);
    this.selectedFiles = undefined;

    this.currentFileUpload = new FileUpload(file);
  //  this.uploadService.pushFileToStorage(this.currentFileUpload, this.progress);
  }

}
